import {
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
} from "@mui/material";
import { makeStyles, createStyles } from "@mui/styles";

import Meal from "./Meal";

const useStyles = makeStyles((_theme) =>
  createStyles({
    table: {
      border: "1px solid #ccc",
      "& th": {
        background: "#ccc",
        color: "white",
        fontWeight: 600,
        textAlign: "center",
      },
    },
    row: {
      "& td": {
        borderRight: "1px solid #ccc",
        padding: 2,
        fontSize: 11,
        textAlign: "left",
        verticalAlign: "top",
        "&:first-child": {
          textAlign: "center",
        },
      },
    },
  })
);

const MealRow = ({ data = {}, label }) => {
  const classes = useStyles();

  return (
    <TableRow className={classes.row}>
      <TableCell>{label}</TableCell>
      <TableCell>
        <Meal data={data["pon"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["uto"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["sre"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["čet"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["pet"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["sub"]} />
      </TableCell>
      <TableCell>
        <Meal data={data["ned"]} />
      </TableCell>
    </TableRow>
  );
};

const WeekTable = ({ week, data }) => {
  const classes = useStyles();

  return (
    <div className="page-break">
      <Table className={classes.table} size="small">
        <TableHead>
          <TableRow>
            <TableCell>#{week}</TableCell>
            <TableCell>Ponedeljak</TableCell>
            <TableCell>Utorak</TableCell>
            <TableCell>Sreda</TableCell>
            <TableCell>Četvrtak</TableCell>
            <TableCell>Petak</TableCell>
            <TableCell>Subota</TableCell>
            <TableCell>Nedelja</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          <MealRow data={data["dorucak"]} label="doručak" />
          <MealRow data={data["uzina1"]} label="užina" />
          <MealRow data={data["rucak"]} label="ručak" />
          <MealRow data={data["uzina2"]} label="užina" />
          <MealRow data={data["vecera"]} label="večera" />
        </TableBody>
      </Table>
    </div>
  );
};

export default WeekTable;
